export default {
  namespaced: true,
  state: {
    all: [],
    loading: false,
  },
  getters: {
    all: state => state.all,
    find: state => id => state.all.find(campaign => campaign.id == id),
    loading: state => state.loading,
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    setAll(state, campaigns) {
      state.all = campaigns.map(c => ({ ...c, $type: 'Campaign' }))
      state.loading = false
    },
    set(state, campaign) {
      state.all = state.all.filter(o => o.id != campaign.id)
      state.all.push({ ...campaign, $type: 'Campaign' })
    },
    remove(state, id) {
      state.all = state.all.filter(o => o.id != id)
    },
  },
  actions: {
    fetchAll({ commit }) {
      this.$authorize('list', 'Campaign')

      commit('startLoading')
      return Vue.$http
        .get('admin/campaigns')
        .then(response => commit('setAll', response.data), response => commit('stopLoading'))
    },
    fetch({ commit }, id) {
      this.$authorize('read', 'Campaign')

      return Vue.$http.get(`admin/campaigns/${id}`).then(response => commit('set', response.data))
    },
    create({ commit }, campaign) {
      this.$authorize('create', 'Campaign')

      return Vue.$http.post('admin/campaigns', { campaign }).then(
        response => {
          if (response.data.errors && response.data.errors.length > 0) {
            commit(
              'snackbar',
              {
                text: 'There was a problem creating the campaign',
                type: 'error',
              },
              { root: true }
            )
            return Object.assign(campaign, response.data)
          } else {
            commit('set', response.data)
            commit(
              'snackbar',
              {
                text: 'Campaign was created successfully',
                type: 'success',
              },
              { root: true }
            )
            return response.data
          }
        },
        response => {
          return response.data
        }
      )
    },
    update({ commit }, campaign) {
      this.$authorize('edit', 'Campaign')

      return Vue.$http.patch(`admin/campaigns/${campaign.id}`, { campaign }).then(
        response => {
          if (response.data.errors && response.data.errors.length > 0) {
            commit(
              'snackbar',
              {
                text: 'There was a problem updating the campaign',
                type: 'error',
              },
              { root: true }
            )
            commit('set', response.data)
            return response.data
          } else {
            commit(
              'snackbar',
              {
                text: 'Campaign was updated successfully',
                type: 'success',
              },
              { root: true }
            )
            commit('set', response.data)
            return {}
          }
        },
        response => {
          commit('set', Object.assign(campaign, response.data))
          return response.data
        }
      )
    },
    destroy({ commit }, id) {
      this.$authorize('delete', 'Campaign')

      return Vue.$http.delete(`admin/campaigns/${id}`).then(response => commit('remove', id))
    },
  },
}
